export default __webpack_public_path__ + "static/media/timer.d3db1d08.svg";